import { useSelector } from "react-redux";
import HtmlContent from "./HtmlContent";

const ACTIONS = {
    pancyr: { type: 'switchPage', payload: 1 },
};

// Keys correspond to window.__APP_HTML entries populated by
// /public/content/about_<lang>.js.
const CONTENT_KEYS = {
    ru: 'about_ru',
    en: 'about_en',
};

const About = () => {
    const rus = useSelector(state => state.rus);
    const lang = rus ? 'ru' : 'en';

    return <HtmlContent contentKey={CONTENT_KEYS[lang]} actions={ACTIONS} />;
};

export default About;
